import { downgradeComponent } from "@angular/upgrade/static";
import { TeamReflectionsComponent } from "@webapp/reflections/components/team-reflections/team-reflections.component";
import { ReflectionContributorListComponent } from "@webapp/reflections/components/reflection-contributor-list/reflection-contributor-list.component";
import { ReflectionDetailsComponent } from "@webapp/reflections/components/reflection-details/reflection-details.component";
import { ReflectionInboxTemplateComponent } from "@webapp/reflections/components/reflection-inbox-template/reflection-inbox-template.component";
import { ReflectionsFacade } from "@webapp/reflections/services/reflections-facade.service";
import { ManageReflectionsComponent } from "@webapp/reflections/components/manage-reflections/manage-reflections.component";
import { ReflectionFormComponent } from "@webapp/reflections/components/reflection-form/reflection-form.component";
import { downgradeInjectable } from "@angular/upgrade/static";

const mod = angular.module("reflections", []);

mod.directive("reflectionDetails", downgradeComponent({ component: ReflectionDetailsComponent }));
mod.directive("reflectionForm", downgradeComponent({ component: ReflectionFormComponent }));
mod.directive("reflectionInboxTemplate", downgradeComponent({ component: ReflectionInboxTemplateComponent }));
mod.directive("teamReflections", downgradeComponent({ component: TeamReflectionsComponent }));
mod.directive("reflectionContributorList", downgradeComponent({ component: ReflectionContributorListComponent }));
mod.directive("manageReflections", downgradeComponent({ component: ManageReflectionsComponent }));

mod.service("ReflectionsFacade", downgradeInjectable(ReflectionsFacade));

export default mod.name;
